// A key value pair of flow components with key name of the data reference pointer

export enum DataPointer {
  MAPPING = 'mapping',
  ENDPOINT = 'endpoint',
  SCHEMA = 'schema'
}

export const OUTPUT_PORT_COMPONENT_ID = '@output';
